<template>
    <div>
        <template>
            <div style="font-size:16px; background-color: #005B5B;">
                <h5 class="text-white text-center">
                    {{ $t('externalUser.' + title) }}
                </h5>
            </div>
        </template>
        <b-table-simple bordered>
                <b-tr>
                    <b-th>{{ $t('hospital_public_panel.area_type') }}</b-th>
                    <b-td colspan="3">{{ data.address_area_type }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('globalTrans.division') }}</b-th>
                    <b-td>{{ data.division }}</b-td>
                    <b-th>{{ $t('globalTrans.district') }}</b-th>
                    <b-td>{{ data.district }}</b-td>
                </b-tr>
            <template v-if="data.address_area_type_id === 1">
                <b-tr>
                    <b-th>{{ $t('hospital_public_panel.city_corporation') }}</b-th>
                    <b-td>{{ data.address_city_corporation }}</b-td>
                    <b-th>{{ $t('hospital_configuration.ward') }}</b-th>
                    <b-td>{{ data.address_ward }}</b-td><b-th v-if="$i18n.locale === 'en'">{{ $t('globalTrans.address') }}</b-th>
                </b-tr>
                <b-tr>
                    <b-td colspan="3" v-if="$i18n.locale === 'en'">{{ data.address }}</b-td>
                    <b-th v-if="$i18n.locale === 'bn'">{{ $t('globalTrans.address') }}</b-th>
                    <b-td colspan="3" v-if="$i18n.locale === 'bn'">{{data.tracking_no === 8 ?  data.patient_welfare_assoc.address_bn : data.address_bn}}</b-td>
                </b-tr>
            </template>

            <template v-if="data.address_area_type_id === 2">
                <b-tr>
                    <b-th>{{ $t('hospital_public_panel.upazila') }}</b-th>
                    <b-td>{{ data.address_upazilla }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('hospital_public_panel.pourashava') }}</b-th>
                    <b-td>{{ data.address_pauroshoba }}</b-td>
                    <b-th>{{ $t('hospital_configuration.ward') }}</b-th>
                    <b-td>{{ data.address_ward }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th v-if="$i18n.locale === 'en'">{{ $t('globalTrans.address') }}</b-th>
                    <b-td colspan="3" v-if="$i18n.locale === 'en'">{{ data.address }}</b-td>
                    <b-th v-if="$i18n.locale === 'bn'">{{ $t('globalTrans.address') }}</b-th>
                    <b-td colspan="3" v-if="$i18n.locale === 'bn'">{{data.tracking_no === 8 ?  data.patient_welfare_assoc.address_bn : data.address_bn}}</b-td>
                </b-tr>
            </template>

            <template v-if="data.address_area_type_id === 3">
                <b-tr>
                    <b-th>{{ $t('hospital_public_panel.upazila') }}</b-th>
                    <b-td>{{ data.address_upazilla }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('hospital_public_panel.union') }}</b-th>
                    <b-td>{{ data.address_union }}</b-td>
                    <b-th>{{ $t('hospital_configuration.ward') }}</b-th>
                    <b-td>{{ data.address_ward }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th v-if="$i18n.locale === 'en'">{{ $t('globalTrans.address') }}</b-th>
                    <b-td colspan="3" v-if="$i18n.locale === 'en'">{{ data.address }}</b-td>
                    <b-th v-if="$i18n.locale === 'bn'">{{ $t('globalTrans.address') }}</b-th>
                    <b-td colspan="3" v-if="$i18n.locale === 'bn'">{{data.tracking_no === 8 ?  data.patient_welfare_assoc.address_bn : data.address_bn}}</b-td>
                </b-tr>
            </template>
        </b-table-simple>
    </div>
</template>
<script>
import Custom from '../../store/custom'

export default {
    props: ['title', 'data'],
    data () {
     return {
         address: {}
     }
    },
    created () {
        this.address = this.data
        // this.manipulateData()
    },
    methods: {
        manipulateData () {
            const areaType = Custom.wardTypeList.find(type => type.id === parseInt(this.address.area_type_id))
            const division = this.$store.state.ExternalUser.commonObj.divisionList.find(item => item.value === parseInt(this.address.division_id))
            const district = this.$store.state.ExternalUser.commonObj.districtList.find(item => item.value === parseInt(this.address.district_id))
            const city = this.$store.state.ExternalUser.commonObj.cityCorporationList.find(item => item.value === parseInt(this.address.city_corporation_id))
            const upazila = this.$store.state.ExternalUser.commonObj.upazilaList.find(item => item.value === parseInt(this.address.upazilla_id))
            const pauroshoba = this.$store.state.ExternalUser.commonObj.pauroshobaList.find(item => item.value === parseInt(this.address.pauroshoba_id))
            const union = this.$store.state.ExternalUser.commonObj.unionList.find(item => item.value === parseInt(this.address.union_id))
            const ward = this.$store.state.ExternalUser.commonObj.wardList.find(item => item.value === parseInt(this.address.ward_id))
            let orgData
            if (this.$i18n.locale === 'bn') {
                orgData = {
                    area_type_name: areaType !== undefined ? areaType.name_bn : '',
                    division_name: division !== undefined ? division.text_bn : '',
                    district_name: district !== undefined ? district.text_bn : '',
                    city_corporation_name: city !== undefined ? city.text_bn : '',
                    upazila_name: upazila !== undefined ? upazila.text_bn : '',
                    pauroshoba_name: pauroshoba !== undefined ? pauroshoba.text_bn : '',
                    union_name: union !== undefined ? union.text_bn : '',
                    ward_name: ward !== undefined ? ward.text_bn : ''
                }
            } else {
                orgData = {
                    area_type_name: areaType !== undefined ? areaType.name : '',
                    division_name: division !== undefined ? division.text : '',
                    district_name: district !== undefined ? district.text : '',
                    city_corporation_name: city !== undefined ? city.text : '',
                    upazila_name: upazila !== undefined ? upazila.text : '',
                    pauroshoba_name: pauroshoba !== undefined ? pauroshoba.text : '',
                    union_name: union !== undefined ? union.text : '',
                    ward_name: ward !== undefined ? ward.text : ''
                }
            }
            this.address = Object.assign({}, this.address, orgData)
        }
    }
}
</script>
